import React from 'react';

import { ButtonHome } from 'Components/ButtonHome';
import ButtonReload from 'Components/ButtonReload';
import { Error } from 'Components/Errors/Error';

import IconNetworkError from './network-error.svg';

export const NetworkError = () => (
  <Error
    title="Comprueba tu conexión"
    message="No logramos procesar tu solicitud, revisa tu conexión a internet."
    icon={<IconNetworkError />}
    reason="NetworkError"
  >
    <ButtonReload />
    <ButtonHome
      linkText={'Ir a\ninicio'}
      openInSelf
    />
  </Error>
);
